import _ from 'lodash';
import lineLimiting from './line-limiting';

function setUpScrolling() {
  const $wires = $('nav.editors-picks-navbar .wires');
  const $wiresInner = $('nav.editors-picks-navbar .wires .wires-inner');
  const $scrollLeftButton = $('#editorsPicksNavbarScrollLeft');
  const $scrollRightButton = $('#editorsPicksNavbarScrollRight');
  const $navbarH2 = $('nav.editors-picks-navbar .wires h2');
  const getWiresInnerWidth = () => _.sumBy($wiresInner.find('article'), a => {
    const $a = $(a);

    return $a.width() + parseFloat($a.css('margin-right'));
  }) + ($navbarH2.is(':hidden') ? 0 : $navbarH2.width()) + 40;

  $wiresInner.css({
    top: 0,
    width: getWiresInnerWidth(),
  });

  $(window).on('resize', _.throttle(() => $wiresInner.css({
    width: getWiresInnerWidth(),
  }), 100));

  function scrollBy(x) {
    $wires.animate({
      scrollLeft: _.clamp($wires[0].scrollLeft + x, 0, getWiresInnerWidth()),
    });
  }

  $scrollLeftButton.on('click', () => scrollBy(-240));
  $scrollRightButton.on('click', () => scrollBy(240));
}

function limitHeadersToTwoLines() {
  function inner() {
    $('nav.editors-picks-navbar article a').each((i, element) => {
      lineLimiting(
        2,
        $ele => {
          const text = $ele.data('original-text') || $ele.text();
          $ele.data('original-text', text);
          return text;
        },
      )($(element));
    });
  }

  $(window).on('resize', _.throttle(() => inner(), 100));
  setTimeout(() => inner(), 100);
}

function showDropShadowOnScroll() {
  $(window).on('scroll', () => {
    const $editorsPickNavBar = $('nav.editors-picks-navbar');
    const contentGap = 30;

    if (window.pageYOffset < contentGap && !!$editorsPickNavBar.length) {
      const boxShadowOpacity = window.pageYOffset / contentGap / 4;

      $editorsPickNavBar.css({
        'box-shadow': `0 2px 5px rgba(0,0,0,${boxShadowOpacity})`,
      });
    } else {
      $editorsPickNavBar.css({ 'background-color': '#fff' });
    }
  });
}

export default function bootstrap() {
  $(() => {
    setUpScrolling();
    limitHeadersToTwoLines();
    showDropShadowOnScroll();
  });
}
